<template>
    <div class="centerContainer1" v-loading.fullscreen="loading1" element-loading-text="下载中..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="vertical-timeline" :style="`min-height:${containerHeight}`" v-if="items && items.length !=0">
            <!-- 时间轴线 -->
            <div class="timeline-line"></div>

            <!-- 时间刻度标记 -->
            <div v-for="(item, index) in items" :key="'marker-'+index" class="timeline-marker"
                :style="{ top: getItemPosition(index) }">
                <div class="marker-dot"></div>
            </div>

            <!-- 内容项 -->
            <div v-for="(item, index) in items" :key="'item-'+index" class="timeline-item"
                :class="index % 2 === 0 ? 'left-item' : 'right-item'" :style="{ top: getItemPosition(index) }">
                <div class="marker-date">{{ formatDate(item.comDate) }}</div>
                <div class="item-card">
                    <div class="card_top">
                        <div class="card_left">
                            <img :src="item.comCover" alt="" style="cursor: pointer;" @click="previewimg(item)">
                        </div>
                        <div class="card_right">
                            {{item.comContent}}
                        </div>
                    </div>
                    <div class="card_bot">
                        <div style="cursor: pointer;" @click="todownload(item,index)">
                            <span style="color: #999;">资料下载</span>
                            <i class="el-icon-download" style="color: #48aa3b;font-size: .18rem;"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
            <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'PcVerticalTimeline',
        props: {
            items: {
                type: Array,
                required: true,
                default: () => [
                    {
                        date: "2023-01-15",
                        title: "项目启动",
                        description: "召开项目启动会议，确定项目目标和时间线"
                    },
                    {
                        date: "2023-03-10",
                        title: "需求分析完成",
                        description: "完成用户需求调研和分析报告，获得客户确认"
                    },
                    {
                        date: "2023-05-20",
                        title: "原型设计",
                        description: "完成产品原型设计并通过内部评审"
                    },
                    {
                        date: "2023-08-15",
                        title: "开发阶段",
                        description: "核心功能开发完成，进入测试阶段"
                    },
                    {
                        date: "2023-11-01",
                        title: "项目交付",
                        description: "系统测试完成并正式交付客户使用"
                    }
                ]
            },
            itemHeight: {
                type: Number,
                default: null // 改为null，由内容决定高度
            }
        },
        data() {
            return {
                loading1: false,
                dialogVisible: false,
                dialogImageUrl: ''
            }
        },
        computed: {
            // 计算容器总高度
            containerHeight() {
                console.log(this.itemHeight, '//////')
                if (this.itemHeight) {
                    return this.items.length * this.itemHeight + 'px';
                }
                // 如果没有设置固定高度，则根据最后一个元素的位置计算
                const lastItem = this.$el.querySelector('.timeline-item:last-child');
                if (lastItem) {
                    const lastItemRect = lastItem.getBoundingClientRect();
                    return lastItemRect.bottom - this.$el.getBoundingClientRect().top + 40 + 'px';
                }
                return 'auto';
            }
        },
        methods: {
            formatDate(dateStr) {
                const date = new Date(dateStr);
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            getItemPosition(index) {
                if (this.itemHeight) {
                    return `${index * this.itemHeight}px`;
                }
                // 动态计算位置
                if (index === 0) return '0px';
                const prevItem = this.$el.querySelector(`.timeline-item:nth-child(${index})`);
                if (prevItem) {
                    const prevRect = prevItem.getBoundingClientRect();
                    return `${prevRect.bottom - this.$el.getBoundingClientRect().top + 40}px`;
                }
                return `${index * 180}px`; // 默认值
            },
            updateLayout() {
                this.$nextTick(() => {
                    // 强制更新布局
                    this.$forceUpdate();
                });
            },
            // 下载
            todownload(item, index) {
                this.loading1 = true
                let fileUrl = item.comFile;
                let fileName = item.comFile.slice(27);
                fetch(fileUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                        // 创建一个临时的URL对象
                        const url = URL.createObjectURL(blob);
                        // 创建一个隐藏的<a>标签，并设置其href属性为临时URL
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = fileName; // 设置下载的文件名
                        a.style.display = 'none';
                        // 将<a>标签添加到文档中，并模拟点击下载
                        document.body.appendChild(a);
                        a.click();
                        // 下载完成后，移除<a>标签和临时URL对象
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                        this.loading1 = false
                    })
                    .catch((error) => {
                        console.error('下载文件时出错:', error);
                        this.$message.error('下载文件时出错')
                        this.loading1 = false
                    });
            },
            // 预览图片
            previewimg(item) {
                this.dialogImageUrl = item.comCover;
                this.dialogVisible = true;
            }
        },
        mounted() {
            window.addEventListener('resize', this.updateLayout);

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateLayout);
        }
    }
</script>

<style scoped>
    .vertical-timeline {
        position: relative;
        max-width: 70%;
        margin: 0 auto;
        padding: 40px 0;
        /* min-height: v-bind(containerHeight); */
        /* 使用计算属性设置高度 */
    }

    /* 时间轴线 */
    .timeline-line {
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 2px;
        background: linear-gradient(to bottom, #999999, #999999);
        transform: translateX(-50%);
        z-index: 1;
    }

    /* 时间刻度标记 */
    .timeline-marker {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 2;
    }

    .marker-dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #999999;
        box-shadow: 0 0 0 2px #999999;
    }

    .marker-date {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #ff9000;
        white-space: nowrap;
        background: white;
        padding: 2px 8px;
        border-radius: 4px;
    }

    /* 内容项通用样式 */
    .timeline-item {
        position: absolute;
        width: calc(50% - 80px);
        transition: all 0.3s ease;
    }

    .item-card {
        padding: 20px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
        border-top: 3px solid #ff9000;
        min-height: 180px;
        /* 最小高度保证一致性 */
    }

    .item-title {
        margin: 0 0 12px 0;
        color: #2c3e50;
        font-size: 18px;
    }

    .item-desc {
        margin: 0;
        color: #555;
        line-height: 1.6;
        font-size: 15px;
    }

    /* 左侧内容项 */
    .left-item {
        left: 0;
        text-align: right;
        padding-right: 60px;
    }

    .left-item .item-card {
        border-top-color: #ff9000;
    }

    /* 右侧内容项 */
    .right-item {
        right: 0;
        text-align: left;
        padding-left: 60px;
    }

    .right-item .item-card {
        border-top-color: #ff9000;
    }

    /* 悬停效果
.timeline-item:hover .item-card {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.12);
} */

    /* 响应高度调整 */
    @media (min-width: 1600px) {
        .timeline-item {
            width: calc(50% - 120px);
        }

        .left-item {
            padding-right: 80px;
        }

        .right-item {
            padding-left: 80px;
        }
    }

    .card_top {
        display: flex;
        width: 100%;
        min-height: 2rem;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding-bottom: .1rem;
        box-sizing: border-box;
    }

    .card_left {
        width: 45%;
    }

    .card_left img {
        width: 100%;
        height: 100%;
        padding-right: .1rem;
        box-sizing: border-box;
    }

    .card_right {
        flex: 1;
        color: #666;
        font-size: 18px;
        text-indent: 2em;
        line-height: 1.8;
    }

    .card_bot {
        padding-top: .1rem;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
    }
</style>


// WEBPACK FOOTER //
// src/components/history/index.vue